import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
import { Button } from './button.js';
import { Tooltip, useSharedTooltipProvider } from './tooltip.js';
/**
 * A square icon-only button with its name in a tooltip — the secondary action
 * of a toolbar or a rail («Отменить», «Читать как текст», a step type).
 *
 * Before it, such buttons carried a native `title`, which shows after a long
 * delay, never on keyboard focus and not at all on touch. The tooltip here
 * opens on hover and on focus; the name is always on `aria-label` as well.
 * `asChild` puts the look and the tooltip on a link instead of a button.
 *
 * Uses the app's `Tooltip.SharedProvider` (AppShell, Storybook); outside one
 * it brings its own provider, so it still works anywhere — a test, a portal
 * rendered elsewhere.
 */
export const IconButton = React.forwardRef(({ label, shortcut, pressed, tooltipSide = 'bottom', variant, className, children, ...props }, ref) => {
    const shared = useSharedTooltipProvider();
    const tooltip = (_jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: _jsx(Button, { ref: ref, size: "icon", variant: variant ?? (pressed ? 'secondary' : 'ghost'), "aria-label": label, "aria-pressed": pressed, className: cn('shrink-0', className), ...props, children: children }) }), _jsxs(Tooltip.Content, { side: tooltipSide, children: [label, shortcut ? _jsx("span", { className: "ml-2 opacity-70", children: shortcut }) : null] })] }));
    return shared ? tooltip : _jsx(Tooltip.Provider, { delayDuration: 300, children: tooltip });
});
IconButton.displayName = 'IconButton';
//# sourceMappingURL=icon-button.js.map